import { render, staticRenderFns } from "./PromoArticles.vue?vue&type=template&id=3a8c7558&scoped=true&"
import script from "./PromoArticles.vue?vue&type=script&lang=ts&"
export * from "./PromoArticles.vue?vue&type=script&lang=ts&"
import style0 from "./PromoArticles.vue?vue&type=style&index=0&id=3a8c7558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c7558",
  null
  
)

export default component.exports